export default __webpack_public_path__ + "static/media/cov-19-notif.801882f2.png";